
import { css, DefaultTheme, FlattenSimpleInterpolation } from 'styled-components';


export const styling = (_theme: DefaultTheme): FlattenSimpleInterpolation => css`
  .barlow-version {
  }
`;
